// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { yupResolver } from '@hookform/resolvers/yup'
import { VALIDATIONS } from 'utils'
import moment from 'moment'
import * as yup from 'yup'

interface IDateRangeProps {
  period: 'begin' | 'end'
  compare: string
  message: string
  options?: {
    compareEqual: boolean
  }
}

declare module 'yup' {
  interface StringSchema {
    name(message: string): StringSchema
    cep(message: string): StringSchema
    date(message?: string): StringSchema
    daterange(props: IDateRangeProps): StringSchema
    password(): StringSchema
    equalsTo(compare: string, message: string): StringSchema
    ngtPassword(message?: string): StringSchema
  }
}

function cep(message: string) {
  return this.test('cep', message, function (value: any) {
    const { path, createError } = this

    if (!/[0-9]{5}-?[0-9]{3}/g.test(value)) {
      return createError({
        message,
        path
      })
    }

    return true
  })
}

function name(message: string) {
  return this.test('name', message, function (value: any) {
    const { path, createError } = this

    if (value?.match(/[^a-zA-Z]/g)?.length > 0) {
      return createError({
        message,
        path
      })
    }

    return true
  })
}

function daterange({ period, compare, message, options }: IDateRangeProps) {
  return this.test('daterange', message, function (value: unknown) {
    const { path, createError, parent } = this

    const validations = {
      begin: (): boolean => {
        if (options && options?.compareEqual) {
          return parent[compare] && moment(parent[compare]).isSameOrAfter(value)
        }

        return parent[compare] && moment(parent[compare]).isAfter(value)
      },
      end: (): boolean => {
        if (options && options?.compareEqual) {
          return (
            parent[compare] && moment(parent[compare]).isSameOrBefore(value)
          )
        }

        return parent[compare] && moment(parent[compare]).isBefore(value)
      }
    }

    if (!value || !parent[compare] || validations[period]()) {
      if (
        moment(moment(value).format('YYYY-MM-DD')).isSame(
          moment(parent[compare]).format('YYYY-MM-DD')
        )
      ) {
        return true
      }

      return true
    }

    if (moment(value).isSame(parent[compare])) {
      return true
    }

    return createError({
      message,
      path
    })
  })
}

function date(message?: string) {
  return this.test('date', message, function (value: unknown) {
    const { path, createError } = this
    const isValidDate = true

    if (!value || moment(value).isValid()) {
      return isValidDate
    }

    return createError({
      message: message || 'Digite uma data válida',
      path
    })
  })
}

function password() {
  return this.test('password', function (value: string) {
    const { path, createError } = this

    if (!VALIDATIONS.minCharacters(value, 8)) {
      createError({
        message: 'Senha deve ter no mínimo 8 caracteres',
        path
      })
    }

    if (!VALIDATIONS.upperCaseCharacter(value)) {
      createError({
        message: 'Senha deve ter no mínimo 1 caractere em caixa alta',
        path
      })
    }

    if (!VALIDATIONS.minLetters(value, 2)) {
      createError({
        message: 'Senha deve ter no mínimo 2 letras',
        path
      })
    }

    if (!VALIDATIONS.lowerCaseCharacter(value)) {
      createError({
        message: 'Senha deve ter no mínimo 1 caractere em caixa baixa',
        path
      })
    }

    if (!VALIDATIONS.minNumbers(value, 2)) {
      createError({
        message: 'Senha deve ter no mínimo 2 números',
        path
      })
    }

    if (!VALIDATIONS.noRepeatWords(value, 2)) {
      createError({
        message: 'Senha não deve haver sequências de caracteres',
        path
      })
    }

    if (!VALIDATIONS.notContentSpaces(value)) {
      createError({
        message: 'Senha não deve conter espaços em branco',
        path
      })
    }

    return true
  })
}

function equalsTo(compare?: string, message?: string) {
  return this.test('date', message, function (value: string) {
    const { path, createError, parent } = this

    if (value !== parent[compare]) {
      return true
    }

    createError({
      message: message || 'Valores não são iguais',
      path
    })
  })
}

function ngtPassword(message?: string) {
  return this.test('ngtPassword', message, function (value: string) {
    const { path, createError } = this

    if (!value) {
      return createError({
        message: 'Campo obrigatório',
        path
      })
    }

    if (value.length < 8) {
      return createError({
        message: 'Senha deve conter no mínimo 8 caracteres',
        path
      })
    }

    if (!VALIDATIONS.notContentSpaces(value)) {
      return createError({
        message: 'Senha não pode conter espaços',
        path
      })
    }

    if (!VALIDATIONS.minNumbers(value, 2)) {
      return createError({
        path,
        message: 'Senha deve conter no mínimo dois números'
      })
    }

    if (!VALIDATIONS.minLetters(value, 2)) {
      return createError({
        path,
        message: 'Senha deve conter no mínimo dois números'
      })
    }

    return true
  })
}

yup.addMethod(yup.string, 'equalsTo', equalsTo)
yup.addMethod(yup.string, 'password', password)
yup.addMethod(yup.string, 'name', name)
yup.addMethod(yup.string, 'cep', cep)
yup.addMethod(yup.string, 'date', date)
yup.addMethod(yup.string, 'daterange', daterange)
yup.addMethod(yup.string, 'ngtPassword', ngtPassword)

export { yupResolver, yup }
